<template>
    <div v-if="visible" @click.self="$emit('close')" class="backdrop-blur-[7px] fixed inset-0 z-50" style="background-color: rgba(53, 53, 53, 0.5)"></div>
    <div
        v-if="visible"
        class="bg-[#252526] w-[600px] max-h-[80vh] rounded-[10px] p-[14px] z-[51] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] border-[1px] border-[#FFF] border-opacity-10 flex flex-col"
        style="box-shadow: 4px 4px 4px 0px #00000040;"
    >
        <div class="font-semibold text-[16px] text-[#fff] mb-3">Обрати відео з медіа-сервера</div>
        <input
            v-model="searchQuery"
            class="bg-[#1e1e1e] border-[#474849] border-[1px] text-white text-[14px] w-full py-2 px-3 rounded-[6px] mb-3"
            placeholder="Пошук за назвою..."
        >
        <div class="flex-1 overflow-y-auto min-h-[200px]">
            <div v-if="loading" class="text-[#A3A3C2] text-center py-8">Завантаження...</div>
            <div v-else-if="filteredFiles.length === 0" class="text-[#A3A3C2] text-center py-8">Відео не знайдено</div>
            <div v-else class="space-y-2">
                <div
                    v-for="file in filteredFiles"
                    :key="file.id"
                    class="flex items-center justify-between p-3 rounded-[6px] bg-[#1e1e1e] hover:bg-[#2d2d2d] cursor-pointer border border-transparent hover:border-[#BD9135]"
                    @click="selectFile(file)"
                >
                    <div class="flex items-center gap-3 min-w-0">
                        <img src="@/assets/icons/video_icon.svg" class="w-8 h-8 flex-shrink-0" alt="">
                        <div class="min-w-0">
                            <div class="text-[#FFF] text-sm font-medium truncate">{{ file.file_name }}</div>
                            <div v-if="file.description" class="text-gray-400 text-xs truncate">{{ file.description }}</div>
                        </div>
                    </div>
                    <button
                        class="ml-2 px-3 py-1 bg-[#BD9135] hover:bg-[#a77f2b] text-white text-sm rounded-[6px] flex-shrink-0"
                        @click.stop="selectFile(file)"
                    >
                        Обрати
                    </button>
                </div>
            </div>
        </div>
        <div class="mt-3 flex justify-end">
            <button
                @click="$emit('close')"
                class="px-4 py-2 bg-[#474849] hover:bg-[#5a5a5b] text-white rounded-[6px]"
            >
                Скасувати
            </button>
        </div>
    </div>
</template>

<script>
    import { ref, computed, watch } from 'vue'
    import { getFileList } from '@/views/FileStorage/services/apiRequests'

    const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.m4v']

    const isVideoFile = (fileName) => {
        const lower = (fileName || '').toLowerCase()
        return VIDEO_EXTENSIONS.some(ext => lower.endsWith(ext))
    }

    export const getFileVideoUrl = (file) => {
        if (!file?.id) return ''
        const base = (process.env.VUE_APP_API_URL || '').replace(/\/*$/, '/')
        const name = (file.file_name || '').toLowerCase()
        const extFromName = VIDEO_EXTENSIONS.find((ext) => name.endsWith(ext))
        const ext = extFromName || '.mp4'
        return `${base}file_storage/${file.id}${ext}`
    }

    export default {
        name: 'MediaServerPicker',

        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },

        emits: ['close', 'select'],

        setup(props, { emit }) {
            const files = ref([])
            const loading = ref(false)
            const searchQuery = ref('')

            const videoFiles = computed(() =>
                files.value.filter(f => isVideoFile(f.file_name))
            )

            const filteredFiles = computed(() => {
                const q = searchQuery.value?.toLowerCase().trim()
                if (!q) return videoFiles.value
                return videoFiles.value.filter(f =>
                    (f.file_name || '').toLowerCase().includes(q) ||
                    (f.description || '').toLowerCase().includes(q)
                )
            })

            const loadFiles = async () => {
                loading.value = true
                try {
                    const res = await getFileList(500, 0)
                    files.value = Array.isArray(res?.data) ? res.data : []
                } catch (err) {
                    console.error('Failed to load media files:', err)
                    files.value = []
                } finally {
                    loading.value = false
                }
            }

            watch(() => props.visible, (v) => {
                if (v) {
                    loadFiles()
                    searchQuery.value = ''
                }
            })

            const selectFile = (file) => {
                const url = getFileVideoUrl(file)
                if (url) {
                    emit('select', url)
                    emit('close')
                }
            }

            return {
                files,
                loading,
                searchQuery,
                filteredFiles,
                selectFile,
                getFileVideoUrl
            }
        }
    }
</script>
